// extracted by mini-css-extract-plugin
export default {"interested_title":"styles_interested_title__IOa5m","interested_container":"styles_interested_container__WvhgT"};